import React from 'react';
import DeliverySelection from './delivery-selection';
import CustomerAddress from './customer-address';

const DeliverySection = ({
  deliveryOptions,
  selectedDeliveryOptions,
  handleDeliveryOptions,
  products,
  outOfStockDeliveryOptions,
}) => {
  const handleChangeDeliveryOptions = (option) => {
    handleDeliveryOptions(option);
  };

  const isMoreOptions = deliveryOptions.length >= 4;

  return (
    <div className={`flex-wrap mb-4 h-100`}>
      <div className="w-100 pt-3 pb-1">
        <CustomerAddress isSingleOption={deliveryOptions.length <= 1} />
      </div>
      <DeliverySelection
        changeDeliveryOptions={handleChangeDeliveryOptions}
        deliveryOptions={deliveryOptions}
        selectedDeliveryOptions={selectedDeliveryOptions}
        products={products}
        isMoreOptions={isMoreOptions}
        outOfStockDeliveryOptions={outOfStockDeliveryOptions}
      />
    </div>
  );
};

export default DeliverySection;
